import { EnvironmentProviders } from '@angular/core';
import { EgBrand, provideEgBrand } from '@expertgroup/shell';
import type { EgLoadedBrand } from '@expertgroup/shell/brand';
import { EN } from '@/app/core/copy/en';
import { trenutniJezik } from '@/app/core/copy/language';
import { SR } from '@/app/core/copy/sr';

/**
 * Podrazumevana maska ProTax-a: ime proizvoda, bez logotipa i bez znaka.
 *
 * Šta je na ekranu bira HOST stranice, a jedini izvor je Identity (`loadEgBrand` u `main.ts`, shell 0.16, ADR 0003 u
 * biblioteci). Host koji nijedan tenant nije claim-ovao — localhost, Static Web App host — dobija `brand: null` i ostaje
 * na ovome. Zato su `logoSrc` i `markSrc` PRAZNI NIZOVI, a ne izostavljeni: šina bez ulaza i bez vrednosti u maski pada na
 * ugrađeni EG logotip, pa bi generički host izgledao kao Expert Group.
 *
 * Ime proizvoda ostaje aplikaciji: Identity ga ne šalje (maska hosta je logotip, znak, favicon, ime organizacije i boje).
 * Ide iz kopije aplikacije, a ne iz konstante, da šina, putanja i naslov taba kažu isto. Rečnik se bira kao i u `COPY` —
 * jednom, pri pokretanju — jer se ovo izvršava pre nego što injektor postoji.
 */
export function protaxBrandDefaults(): EgBrand {
    const copy = trenutniJezik() === 'en' ? EN : SR;
    return { productName: copy['layout.brand.name'], logoSrc: '', markSrc: '' };
}

/**
 * Maska hosta preko podrazumevane maske ProTax-a. `brand` je ono što je vratio `loadEgBrand`: maska, ili `null` kad host
 * nema masku (ili Identity nije odgovorio).
 *
 * Spread je bezbedan iz dva razloga: `null` se spread-uje u ništa, a loader nikad ne vraća ključ sa `undefined`
 * vrednošću, pa ne briše podrazumevanu vrednost. Tenant bez logotipa tako dobija `logoSrc: ''` iz LOADERA (ne EG logotip).
 */
export function provideProtaxBrand(brand: EgLoadedBrand | null): EnvironmentProviders {
    return provideEgBrand({ ...protaxBrandDefaults(), ...brand });
}
